//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.LeadAngles.js";
let d=[[[0,"BladeSwarfCollisionHandling",1,0],[0,"BladeSwarfExtensionAlignment",1,0],[0,"BladeSwarfExtensionStartAngle",1,0],[0,"InterpolateVector",0,"CAM.InterpolateVector",0],[0,"LeadingAngle",1,1],[0,"MinimumLeadAngle",1,0],[0,"PreviewMaximumDistanceBuilder",0,"CAM.InheritableToolDepBuilder",0],[1,"PrimaryLeadAngles",0,"CAM.LeadAngles",0],[0,"RotateAbout",1,0],[1,"SecondaryLeadAngles",0,"CAM.LeadAngles",0],[0,"SmoothingMethod",1,0],[0,"SplitterAngle",1,0],[0,"SwarfGougeCheck",1,0],[0,"TiltAngle",1,0],[0,"ToolAxisAdvancedVector",1,"Direction",0],[0,"ToolAxisType",1,0],[0,"TrailingAngle",1,1],[0,"TrailingEdgeClearanceAngle",1,0]],[],[]];
SPLM.CAM.ToolAxisAdvanced = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolAxisAdvanced";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolAxisAdvanced.Type = Object.freeze({
    "Automatic" : "Automatic", "InterpolateVector" : "InterpolateVector", "BladeSwarf" : "BladeSwarf", "FollowBladeUv" : "FollowBladeUv", "Fixed" : "Fixed"});

SPLM.CAM.ToolAxisAdvanced.RotateAboutType = Object.freeze({
    "PartAxis" : "PartAxis", "Blade" : "Blade"});

SPLM.CAM.ToolAxisAdvanced.BladeSwarfCollisionHandlingType = Object.freeze({
    "ContactTopAndBottom" : "ContactTopAndBottom", "Degouge" : "Degouge", "Balance" : "Balance"});

SPLM.CAM.ToolAxisAdvanced.BladeSwarfExtensionAlignmentType = Object.freeze({
    "Automatic" : "Automatic", "AlignToEdges" : "AlignToEdges", "StartAngle" : "StartAngle"});

export default SPLM;